// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2coAo","container":"styles_container__1Yx8p","title":"styles_title__3-m1J","wrapper":"styles_wrapper__2GrOy","answer":"styles_answer__kDlMa"};